import { ListBoxTransferModal } from 'components/modals/ListBoxTransferModal';
import { func_validation, isArrayNotEmpty } from 'functions';
import React, { useState } from 'react';

export function useAccountAutomation(props) {
    const {
        getNonautomatedAccountList_requesting,
        getAutomatedAccountList_requesting,
        removeAutomatedAccounts_requesting,
        removeAutomatedAccounts_status,
        addAutomatedAccounts_requesting,
        addAutomatedAccounts_status,
        nonautomatedAccountList,
        automatedAccountList,
    } = props;

    const [isModalVisible_accountAutomation, setIsModalVisible_accountAutomation] = useState(false);

    
    function handleAddAutomatedAccounts(accounts) {
        if (func_validation.isArrayNotEmpty(accounts) &&
            props.addAutomatedAccounts) {

            // Reformat data
            let accounts_new = accounts.map((account, idx) => {
                return {
                    id: 0,
                    AccountCode: account
                }
            })
            props.addAutomatedAccounts(accounts_new);
        }
    }
    function handleRemoveAutomatedAccounts(accounts) {
        if (props.removeAutomatedAccounts)
            props.removeAutomatedAccounts(accounts);
    }
    
    let accountAutomationModal = (
        <ListBoxTransferModal
            isModalVisible={isModalVisible_accountAutomation}
            updateParentState={setIsModalVisible_accountAutomation}

            title={"Automate"}

            leftBoxTitle={"Account List"}
            getLeftListBoxList={props.getNonautomatedAccountList}
            leftBoxList={isArrayNotEmpty(nonautomatedAccountList)? 
                nonautomatedAccountList.map((code) => {
                    return {
                        label: code, 
                        data: code, 
                        isSelected: false, 
                    }
                }
            ):""}
            leftListBoxData_requesting={getNonautomatedAccountList_requesting}
            leftBox_onClick={handleAddAutomatedAccounts}
            leftActionButtonTxt={"Add"}
            leftListBoxAction_status={addAutomatedAccounts_status}
            leftListBoxAction_requesting={addAutomatedAccounts_requesting}
            leftListBoxOptions={{
                isSearchable: true,
                searchInputPlaceholder: "Search Account Code",
                isActionDisabled: func_validation.isUserAccessDenied(props, "Internal_AutomateList_Add"),
                isResetRequired: addAutomatedAccounts_status
            }}

            rightBoxTitle={"Automated Accounts"}
            getRightListBoxList={props.getAutomatedAccountList}
            rightBoxList={isArrayNotEmpty(automatedAccountList)? 
                automatedAccountList.map((code) => {
                    return {
                        label: code, 
                        data: code, 
                        isSelected: false, 
                    }
                }
            ):""}
            rightListBoxData_requesting={getAutomatedAccountList_requesting}
            rightBox_onClick={handleRemoveAutomatedAccounts}
            rightActionButtonTxt={"Remove"}
            rightListBoxAction_status={removeAutomatedAccounts_status}
            rightListBoxAction_requesting={removeAutomatedAccounts_requesting}
            rightListBoxOptions={{
                isSearchable: true,
                searchInputPlaceholder: "Search Account Code",
                isActionDisabled: func_validation.isUserAccessDenied(props, "Internal_AutomateList_Delete"),
                isResetRequired: removeAutomatedAccounts_status
            }}   
            
            // Note: Permission to allow user to process automation not in UI.
            //       "Internal_AutomateList_AutomateProcess"
        />
    );

    return {
        accountAutomationModal,
        setIsModalVisible_accountAutomation
    }
}